export default "__VITE_ASSET__DYgGyjcT__"